<template>
  <Modal v-model="attributePoolModal" :title="$t('key1003492')" width="800" :transfer="false" :mask-closable="false"
    class-name="attributePoolStyle" @on-visible-change="attributePoolModalChange">
    <Form ref="distributorsForm" :model="attributePoolForm" @submit.native.prevent>
      <Row>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item prop="name">
            <div style="display: flex;align-items: center;">
              <Input clearable v-model.trim="attributePoolForm.name" :placeholder="$t('key1003493')"
                style="width: 300px;" @keydown.native.enter.prevent="getList()"></Input>
              <Button type="primary" style="margin-left: 20px;" @click="getList()">{{ $t('key1000011') }}</Button>
            </div>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="550"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="getSelectValue">
      </Table>
    </div>
    <template #footer>
      <Button @click="attributePoolModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="attributePoolBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "attributePoolModal",
  mixins: [Mixin],
  props: {
    // 商品分类的--商品属性列表数据
    attributeTableData: {
      type: Array,
      default: () => []
    },
    // 商品分类的--商品规格列表数据
    specificationsTableData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      attributePoolModal: false,
      attributePoolForm: {
        attributeRequire: null, // 属性填写要求，0：必填，1：非必填，2：选填
        attributeType: null, // 属性类型(0:基础属性 1:规格属性 null 全部)
        chooseType: null, // 可选值类型定义 0:多选 1:单选
        isAllowCustomValue: null, // 是否允许自定义属性值(0:不允许 1:允许)
        isSizeAttribute: null, // 是否尺码属性，0：否，1：是
        name: '',
        status: 1, // 状态 0 停用 1 启用
        orderBy: 'createdTime',
        upDown: 'down',
        ymsSiteId: null
      },
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000396'),
          key: 'cnName',
          minWidth: 100,
          align: 'center'
        },
        /*{
          title: '属性值类型',
          key: 'type',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let typeArr = ['自定义', '可选值'];
            let txt = typeArr[params.row.type];
            return h('span', txt);
          }
        },*/
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000399'),
          key: 'attributeRequire',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let typeArr = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000304'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000305'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000306')];
            let txt = typeArr[params.row.attributeRequire];
            return h('span', txt);
          }
        }
      ],
      tableData: [],
      selectAttributeData: [],
      ymsProductAttributeTemplateId: null,
    };
  },
  created() {

  },
  methods: {
    // 初始化数据
    initAttributePoolData(attributeType, ymsSiteId, ymsProductAttributeTemplateId) {
      this.attributePoolForm.attributeType = attributeType;
      this.attributePoolForm.status = 1; // 获取已启用数据
      this.attributePoolForm.ymsSiteId = ymsSiteId || null;
      this.ymsProductAttributeTemplateId = ymsProductAttributeTemplateId || null;
      this.getList();
      this.attributePoolModal = true;
    },
    // 获取属性池选择的数据
    getList(obj) {
      let v = this;
      v.tableLoading = true;
      v.tableData = [];
      v.selectAttributeData = [];
      let query = Object.assign({}, v.attributePoolForm);
      if (v.ymsProductAttributeTemplateId) {
        query.excludeCurrentTemplateId = v.ymsProductAttributeTemplateId;
      }
      v.axios.post(api.post_ymsProductAttributeTemplate_query, query).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            v.tableData = data;
            if (obj) {
              data.map((item) => {
                if (item.ymsProductAttributeTemplateId === obj.ymsProductAttributeTemplateId) {
                  v.attributePoolForm.attributeType = obj.attributeType;
                  v.selectAttributeData.push(item);
                  v.attributePoolBtn('check');
                }
              });
            }
          }
        }
      });
    },
    // 勾选属性池管理的数据
    getSelectValue(value) {
      this.selectAttributeData = value;
    },
    // 属性池管理弹窗的确定按钮
    attributePoolBtn(type) {
      let newList = [];
      if (this.selectAttributeData.length > 0) {
        this.selectAttributeData.map((item) => {
          item.keyWordsType = '3'; // listing关键词的生成规则-->默认为不选
        });
        // 商品规格(只能有一个是尺码属性)
        if (this.attributePoolForm.attributeType === 1) {
          // 如果列表里有几个存在了有尺码属性的，新增的是尺码属性的默认不添加到规格列表中
          if (type === 'check') {
            let arr = [...this.specificationsTableData, ...this.selectAttributeData];
            let selectTalg = this.selectAttributeData.some(item => item.isSizeAttribute === 1);
            let talg = this.specificationsTableData.some(item => item.isSizeAttribute === 1);
            if (!(talg && selectTalg)) {
              newList = this.uniqueFunc(arr, 'ymsProductAttributeTemplateId');
            }
          } else {
            let arr = [...this.specificationsTableData, ...this.selectAttributeData];
            if (arr.length > 0) {
              let list = arr.filter((item) => {
                return item.isSizeAttribute === 1;
              });
              if (list.length >= 2) {
                this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003490'));
                return false;
              }
              newList = this.uniqueFunc(arr, 'ymsProductAttributeTemplateId');
            }
          }
          this.$emit('updateSpecificationsTableData', newList);
        }
        // 商品属性
        else if (this.attributePoolForm.attributeType === 0) {
          let arr = [...this.attributeTableData, ...this.selectAttributeData];
          newList = this.uniqueFunc(arr, 'ymsProductAttributeTemplateId');
          this.$emit('updateAttributeTableData', newList);
        }
        this.attributePoolModal = false;
        this.selectAttributeData = [];
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003491'));
      }
      if (type === 'check') {
        setTimeout(() => {
          this.resetData();
        }, 800);
      }
    },
    // 监听属性池管理弹窗
    attributePoolModalChange(value) {
      let v = this;
      if (!value) {
        v.resetData();
      }
    },
    resetData() {
      let v = this;
      v.attributePoolForm = {
        attributeRequire: null,
        attributeType: null,
        chooseType: null,
        isAllowCustomValue: null,
        isSizeAttribute: null,
        name: '',
        status: 1
      };
      v.tableData = [];
      v.selectAttributeData = [];
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .attributePoolStyle {
  .ivu-modal-body {
    max-height: 650px;
    overflow-y: auto;
  }
}
</style>